// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"Subscribe_subscribe__3Mew0"};